import { render, staticRenderFns } from "./base-card.vue?vue&type=template&id=66419b1d&"
import script from "./base-card.vue?vue&type=script&lang=js&"
export * from "./base-card.vue?vue&type=script&lang=js&"
import style0 from "./base-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports